import React, { useEffect, useState } from 'react';
import Switch from 'react-switch';
import PageHead from '../components/PageHead';
import { useCoupons } from '../hooks/useCoupons';
import Loading from '../components/Loading';
import { exportButton } from '../utils/config';
import Button from '../ui/comp/Button';
import { CiExport } from 'react-icons/ci';
import { FiEdit, FiPlus } from 'react-icons/fi';
import Input from '../ui/forms/Input';
import AddCoupon from '../components/coupon/AddCoupon';
import UpdateCoupon from '../components/coupon/UpdateCoupon';
import Container from '../ui/comp/Container';
import NoContent from '../components/NoContent';
import Table from '../ui/Table/Table';
import Thead from '../ui/Table/Thead';
import Td from '../ui/Table/Td';
import Tbody from '../ui/Table/Tbody';
import { CgTrash } from 'react-icons/cg';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Axios } from '../utils/Axios';
import { useLocation, useNavigate } from 'react-router-dom';

const Coupons = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { data, isLoading, error } = useCoupons()
    const [coupons, setCoupons] = useState([])
    const [SearchText, setSearchText] = useState("")
    const [isAddCouponOpen, setIsAddCouponOpen] = useState(false)
    const [isUpdateCouponOpen, setIsUpdateCouponOpen] = useState(false)

    const queryClient = useQueryClient();

    useEffect(() => { setCoupons(data || []) }, [data])


    // handleChangeSwitch

    const { mutate } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/coupon/change-active', formData)
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['coupons'])
        }
    })

    const handleChangeSwitch = (id) => {
        mutate({ id })
    }

    // Delete
    const { mutate: deleteMutate } = useMutation({
        mutationFn: async (formData) => {
            return Axios.delete('/coupon/delete?id=' + formData?.id)
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['coupons'])
        }
    })

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete")) {
            deleteMutate({ id })
        }
    }


    if (isLoading) {
        return <Loading />
    }

    if (error) {
        return (
            <div>Error Occured</div>
        )
    }

    return (
        <div className='w-full relative'>

            {/* Add Coupon */}

            {isAddCouponOpen && <AddCoupon onClose={() => setIsAddCouponOpen(false)} />}

            {isUpdateCouponOpen && <UpdateCoupon onClose={() => {
                const searchparams = new URLSearchParams(location.search);
                searchparams.delete('coupon');
                navigate(`${location.pathname}?${searchparams.toString()}`)
                setIsUpdateCouponOpen(false)
            }
            }
            />}

            <PageHead title="Coupons" />


            {/* Filter palce */}
            <div className="flex items-center justify-between w-full mt-8">
                <div className='max-w-48 w-full'>
                    <Button
                        onClick={() => exportButton("coupons")}
                        color={'primary'}
                        icon={<CiExport size={18} />}
                    >
                        Export
                    </Button>
                </div>

                <div className='flex items-center gap-3'>
                    <Input placeholder="Coupon name" onChange={(e) => {
                        setSearchText(e.target.value)
                    }} />
                    <Button onClick={() => setIsAddCouponOpen(true)} icon={<FiPlus />} >Add Coupon</Button>
                </div>
            </div>



            {/* Data Area */}
            <div className="mt-8 w-full">
                {data && data?.length ? (
                    <Container>
                        <Table>
                            <Thead>
                                <tr>
                                    <Td>Code</Td>
                                    <Td>Publish</Td>
                                    <Td>Start Date</Td>
                                    <Td>End Date</Td>
                                    <Td>Actions</Td>
                                </tr>
                            </Thead>

                            <Tbody>
                                {coupons.filter(coupon => coupon?.code?.toLowerCase()?.includes(SearchText.toLowerCase()))?.map((cou, i) => (
                                    <tr key={i}>
                                        <Td>{cou?.code}</Td>
                                        <Td>
                                            <Switch
                                                checked={cou?.active}
                                                onChange={() => handleChangeSwitch(cou?.id)}
                                                checkedIcon={false}
                                                uncheckedIcon={false}
                                                onColor='#180787'
                                                height={18}
                                                handleDiameter={14}
                                                width={38}
                                            />
                                        </Td>
                                        <Td>{new Date(cou?.start).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</Td>
                                        <Td>{new Date(cou?.end).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</Td>

                                        <Td>
                                            <div className="flex items-center gap-3 text-gray-500">
                                                <button
                                                    onClick={() => {
                                                        const searchparams = new URLSearchParams(location.search);
                                                        searchparams.set("coupon", cou?.id);
                                                        navigate(`${location.pathname}?${searchparams.toString()}`)
                                                        setIsUpdateCouponOpen(true)
                                                    }}
                                                    className='text-primary' title='Edit'><FiEdit size={17} /></button>
                                                <button onClick={() => handleDelete(cou?.id)} title='Delete' className='text-red-400'><CgTrash size={18} /></button>
                                            </div>
                                        </Td>
                                    </tr>
                                ))}
                            </Tbody>
                        </Table>
                    </Container>
                ) : <NoContent />}
            </div>

        </div>
    );
}

export default Coupons